import { Button } from "antd";
import { useIntl } from "react-intl";
import { useUserUpdates } from "~context/UserUpdatesContext/UserUpdatesContext.tsx";
import { NotificationStatuses } from "~enums/notificationStatuses.ts";
import { NotificationItemBody } from "~pages/Notifications/components/NotificationItemBody.tsx";
import { useMarkAsReadNotification } from "~pages/Notifications/hooks/useMarkAsReadNotification.ts";
import type { Notification } from "~types/notification.ts";

type Props = {
  notification: Notification;
};

export const ExportNotificationItem = ({ notification }: Props) => {
  const { formatMessage } = useIntl();
  const { mutateAsync: markAsRead } = useMarkAsReadNotification();
  const { refetch: refetchUserUpdates } = useUserUpdates();

  const downloadButton = (
    <Button
      type="primary"
      key="download"
      href={notification.data.DownloadUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none" }}
      onClick={() => {
        if (notification.unread) {
          markAsRead(notification.key);
        }
        refetchUserUpdates();
      }}
    >
      {formatMessage({ id: "download" })}
    </Button>
  );

  const customButtons = notification.status === NotificationStatuses.Completed && notification?.data?.DownloadUrl ? [downloadButton] : [];

  return <NotificationItemBody notification={notification} icon="fa-file-export" customButtons={customButtons} />;
};
